module.exports = "//cdn.mxpnl.com/static/asset-cache/b5c882008f292dfd037350c1805fd6bb/iron/common/widgets/intro/images/profiles/brad.svg";